import React, { useState } from 'react'
import PropTypes from "prop-types";
import stylesheet from "./../../../../ReusableComponents/DatePicker/style.module.css";
import { FormHelperText, InputLabel, Typography } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import "react-datetime/css/react-datetime.css";
import Datetime from "react-datetime";
import moment from 'moment';
import SvgDate from "./../../../../ReusableComponents/DatePicker/icons/calender.svg"
import 'moment/locale/ar';
import 'moment/locale/ar-sa';
import 'moment/locale/de';
import 'moment/locale/es';
import 'moment/locale/es-do';
import 'moment/locale/fr-ca';
import 'moment/locale/nl';
import 'moment/locale/pt';
import 'moment/locale/th';
import 'moment/locale/vi';
import 'moment/locale/zh-cn';
import 'moment/locale/zh-hk';
import 'moment/locale/zh-tw';

const useStyle = makeStyles(theme => {
    return {
        container1: {
            display: "flex",
            flexDirection: "column",
            alignItems: props => props.direction == "ltr" ? 'start' : 'end',
            direction: (window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA") ? "rtl" : "ltr",
            justifyContent: props => props.direction == "ltr" ? 'flex-start' : 'flex-end'
        },
        inputDate: {
            '& input': {
                marginRight: (window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA") ? "unset" : "2px !important",
                marginLeft: (window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA") ? "2px !important" : "unset",
                borderRadius: '2px',
                height: '27px',
                border: `1px solid ${theme.palette.borderColor}`,
                fontSize: '11px',
                paddingLeft: '5px',
                '&::placeholder': {
                    fontSize: '11px',
                }
            },
            "& .input_calender": {
                position: 'relative',
                cursor: props => props.disabled ? 'default' : 'pointer',
                '& .wrapper_image': {
                    position: 'absolute',
                    right: props => props.translationStyles1 ? 'unset' : '4px',
                    left: props => props.translationStyles1 ? '4px' : 'unset',
                    height: '16px',
                    top: '1px',
                    padding:"4px 0"
                }
            },
            '& .rdtPicker': {
                top: props => props.align === "top"
                    ? '-230px'
                    : props.align === "left"
                        ? '-50%'
                        : '28px',
                left: props => props.align === "top" ? '30%' : 0,
                padding: 0,
                border: 'none',
                '& table': {
                    direction: (window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA") ? "rtl" : "ltr",
                },
            }
        },
        container: {
            direction: (window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA") ? "rtl" : "ltr",
            display: 'flex',
            alignItems: 'center'
        },
        input_label_root: { display: "contents" },
        input_label: (props) => {
            return {
                ...theme.typography.input_label,
                minWidth: props.labelMinWidth, maxWidth: props.labelMaxWidth,
                textAlign: props.direction == "ltr" ? 'left' : 'right'
            }
        },
    }
})

const renderInput = (props, openCalendar, onFocusCallback, isClear, setIsClear, calenderRequired, readOnly, disabled) => {

    if (isClear) {
        (() => {
            props.onChange({ target: { value: "" } });
            setIsClear(false)
            return;
        })()
    }

    return (
        <div className={"input_calender"}>
            <input aria-label={"Input Date"} {...props}
                   id={props.id || "inputDateEle"}
                   readOnly={readOnly}
                   onFocus={onFocusCallback}
                   onClick={(e) => {
                       if (calenderRequired) {
                           openCalendar(e);
                       }
                   }}
            />
            {
                calenderRequired &&
                <div onClick={(e) => {
                    if (!disabled)
                        openCalendar(e)
                }} className="wrapper_image" >
                    <img src={SvgDate} alt="calender icon" />
                </div>
            }
        </div >
    );
}

const renderCalenderView = (mode, renderDefault) => {
    const translationStyles1=window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA";

    return (
        <div className="wrapper" style={{
            background: '#fff',
            boxShadow: '0 1px 3px rgb(0 0 0 / 10%)',
            border: '1px solid #f9f9f9',
            position: 'absolute',
            right:translationStyles1?null:"133px",
            width: '250px',
        }}>
            { renderDefault()}
        </div >
    );
}

export const DatePickers = props => {
    const translationStyles1=window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA";
    const globalSettings ="";
    const [isClear, setIsClear] = useState(false);
    const [clearHappening, setClearHappening] = useState(false)

    const {
        label = null,
        helperText = null,
        value = "",
        onChange = null,
        name = "input_box",
        labelMinWidth = "95px",
        labelMaxWidth = "95px",
        disabled = props.disableDate,
        align = 'bottom',
        form = true,
        required = false,
        dateFormat = globalSettings.date_format ? globalSettings.date_format : "DD/MM/YYYY",
        placeholder = globalSettings.date_format ? globalSettings.date_format : "DD/MM/YYYY",
        timeFormat = "h:mm A", // to disable time just pass 'false' boolean
        className = "",
        disableBefore = "",
        disableAfter = "",
        onFocusCallback = null,
        direction = 'ltr',
        calenderRequired = true,
        readOnly = true,
        dateClearBoolean,
        dateClearHandler,
        ArabicLanguage,
        ...rest
    } = props;

    const classes = useStyle({ labelMinWidth, labelMaxWidth, align,direction, translationStyles1, disabled, form });

    let inputProps = {
        id: name,
        name: name,
        disabled: disabled,
        required: required,
        placeholder: placeholder,
        className: className,
        autoComplete: "off",
    }

    const lastDay = moment(disableBefore);
    const futureDay = moment(disableAfter);

    const valid = current => {
        if (disableBefore !== "" && disableAfter !== "")
            return current.isBetween(lastDay, futureDay)
        else if (disableAfter !== "")
            return current.isSameOrBefore(futureDay)
        else if (disableBefore !== "")
            return current.isSameOrAfter(lastDay);
        else
            return true
    }

    const clearDate = () => {
        setIsClear(true)
        setClearHappening(true)
    }

    React.useEffect(()=>{
        if(dateClearBoolean===true){
            clearDate();
            dateClearHandler(false);
        }

    },[dateClearBoolean]);

    const onChangeHandler = (val) => {
        if (!clearHappening) {
            if (timeFormat && dateFormat){
                onChange({ target: { name: name, value: moment(val._d).format(`YYYY-MM-DD ${timeFormat}`) } }, clearDate);
            }
            else if (timeFormat){
                onChange({ target: { name: name, value: moment(val._d).format(timeFormat) } }, clearDate);
            }
            else {
                const a = moment(val._d).format(`YYYY-MM-DD`)
                const c = moment.locale()
                moment.locale(val?._locale?._abbr ? (ArabicLanguage === "Hijri" && translationStyles1) ? "ar" : "en" : "en")
                const b = moment(val._d).format(`YYYY-MM-DD`)
                const d = moment.locale()
                onChange({ target: { name: name, value: moment(val._d).format(`YYYY-MM-DD`) } }, clearDate);
            }
        }
        else{
            setClearHappening(false);
        }

    }

    return (
        <div className={form ? classes.container : classes.container1} id={props.id || "dateInputWrapper"}>
            {label != null && (
                <InputLabel
                    shrink
                    htmlFor={name}
                    className={stylesheet.labeltype}
                    classes={{ root: classes.input_label_root }}
                >
                    <Typography noWrap={true} variant="div" className={classes.input_label}> {label}{required && <span className={classes.required_field}>*</span>}</Typography>
                </InputLabel>
            )}
            <div>
                <Datetime
                    ref={props.ref}
                    dateFormat={dateFormat}
                    timeFormat={timeFormat}
                    inputProps={inputProps}
                    className={classes.inputDate}
                    renderInput={(props, openCalendar) => renderInput(props, openCalendar, onFocusCallback, isClear, setIsClear, calenderRequired, readOnly, disabled)}

                    closeOnClickOutside={true}
                    closeOnSelect={true}
                    initialValue={
                        value !== ""
                            ? timeFormat
                                ? moment(value, `YYYY-MM-DD ${timeFormat}`).format(`${dateFormat} ${timeFormat}`)
                                : moment(value, 'YYYY-MM-DD').format(dateFormat)
                            : ""
                    }

                    locale={localStorage.getItem('i18nextLng')}
                    isValidDate={valid}
                    onChange={(val) => onChangeHandler(val)}
                    renderView={(mode, renderDefault) =>
                        renderCalenderView(mode, renderDefault)
                    }
                    minDate={translationStyles1 ? "14/03/1937" : "01/01/1900"}
                    maxDate={translationStyles1 ? "26/11/2076" : "31/12/2100"}
                    {...rest}
                />

                {helperText != null &&
                    form && (
                        <FormHelperText id="my-helper-text" className={classes.helper_text}>{helperText}</FormHelperText>
                    )}
            </div>
        </div>
    );
}

DatePickers.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    value: PropTypes.string,
    required: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    helperText: PropTypes.string,
    labelMinWidth: PropTypes.string,
    labelMaxWidth: PropTypes.string,
    disabled: PropTypes.bool,
    align: PropTypes.string, // bottom || top || left
    form: PropTypes.bool,
    dateFormat: PropTypes.string, // "DD/MM/YYYY" || false
    timeFormat: PropTypes.string || PropTypes.bool, // "h:mm A" || false
    className: PropTypes.string,
    direction: PropTypes.string,
    disableBefore: PropTypes.string,
    disableAfter: PropTypes.string,
    onFocusCallback: PropTypes.func,
    calenderRequired: PropTypes.bool,
    readOnly: PropTypes.bool,
};
